import { SyntheticEvent, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useProductQuery } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";
import { ILocation, RentalLocationType } from "../../../../../../types";
import { IFormValues } from "../../../../types";
import LocationHelperText from "../location-helper-text/location-helper-text";

const FormDropoffLocation = () => {

    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });
    const dropoffLocation = useWatch<IFormValues, 'basicDetails.dropoffLocation'>({
        name: 'basicDetails.dropoffLocation'
    });
    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenant" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealer" });

    const locationsQuery = useProductQuery(
        {
            segment: rentalType,
            businessContinuityInsToolMode: false,
            tenant: tenant as string,
            dealer: dealer as string
        },
        {
            refetchOnMount: false
        }
    );

    const onChange = useCallback((_: SyntheticEvent<Element, Event>, value: ILocation | null) => {
        if (value) {
            formContext.trigger('basicDetails.dropoffLocation');
        }
        formContext.trigger('basicDetails.dropoffDate');
    }, [])

    return (
        <FormAutocomplete<IFormValues>
            name="basicDetails.dropoffLocation"
            label={t('label.dropoffLocation')}
            options={locationsQuery.data?.locations ?? []}
            onChange={onChange}
            loading={locationsQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            textFieldProps={{
                helperText: <LocationHelperText location={dropoffLocation} locationType={RentalLocationType.Dropoff} />
            }}
        />
    );
}

export default FormDropoffLocation;
